import { isInternalHostname, normalizeHost } from '@marketplace-web/browser/url-util'
import { universalEnvs } from '@marketplace-web/environment/environment-util/server'

import {
  API_GATEWAY_DEFAULT_SUBDOMAIN,
  API_GATEWAY_EDGE_SUBDOMAIN,
  API_GATEWAY_TRANSPARENT_PROXY_PATH,
  ApiGatewayType,
} from '../constants'

export const resolveApiGatewayUrl = (type: ApiGatewayType) => {
  const shouldUseTransparentProxy = Boolean(universalEnvs.SHOULD_USE_API_GATEWAY_TRANSPARENT_PROXY)

  if (shouldUseTransparentProxy) return API_GATEWAY_TRANSPARENT_PROXY_PATH

  const hostname = typeof window !== 'undefined' && window.location.host ? window.location.host : ''
  const normalizedHostname = normalizeHost(hostname)

  if (!isInternalHostname(normalizedHostname)) return API_GATEWAY_TRANSPARENT_PROXY_PATH

  const urlArray: Array<string> = []

  if (type === ApiGatewayType.Edge) {
    urlArray.push(API_GATEWAY_EDGE_SUBDOMAIN)
  } else {
    urlArray.push(API_GATEWAY_DEFAULT_SUBDOMAIN)
  }

  if (normalizeHost(hostname).includes('com')) {
    urlArray.push('www')
  }

  urlArray.push(normalizedHostname)

  return `https://${urlArray.join('.')}`
}
